module.exports = __webpack_public_path__ + "fa-regular-400.766913e6c0088ab8c9f7.ttf";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf
// module chunks = 2